module.exports = __webpack_public_path__ + "img/20200617.30e4aa01.png";